export const DEFAULT_OPTIONS = {
  debug: false,

  padding: 50,
  width: 500,
  height: 500,
  dpr: 2,
  browser: true,
  autoskip: true,

  dotsPerRow: 10,
};

export const DIRECTION_DICTIONARY = [
  {
    x: 2,
    y: -1,
  },
  {
    x: 2,
    y: 1,
  },
  {
    x: 0,
    y: 2,
  },
  {
    x: -2,
    y: 1,
  },
  {
    x: -2,
    y: -1,
  },
  {
    x: 0,
    y: -2,
  },
];

export const BLUR_LEVELS = [2, 2, 2, 3, 5, 6];

export const QUALITY_THRESHOLD = 0.75;
